// src/components/appComponents/AuthLayout.js
// Shell for every signed-in page: the sidebar on the left, the routed page on the right.
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import AppSidebar from '../../myNavbar/AppSidebar';
import './authLayout.css';

// Tab title per section; pages showing one workspace / video set a more specific one
const sectionTitle = path =>
  path.startsWith('/workspace') ? 'Workspace'
  : path.startsWith('/bumper') ? 'Creator Studio'
  : path.startsWith('/settings') ? 'Settings'
  : path.startsWith('/help') ? 'Help'
  : path.startsWith('/404') ? 'Not found'
  : null;

const AuthLayout = ({ isSidebarOpen, toggleSidebar }) => {
  const section = sectionTitle(useLocation().pathname);
  return (
    <div className="app-shell">
      <Helmet><title>{section ? `Bumpups | ${section}` : 'Bumpups'}</title></Helmet>
      <AppSidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} />
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AuthLayout;
